import angular from 'angular';

import notificationModule from '../ui/notification/notification.module';
import { sectionSvgUpload } from './section.svg.upload.directive';
import { SectionSvgUpload } from './section.svg.upload.resource';
import './SvgMarkupEditorButtonDirective';

export default angular
  .module('section.svg.upload', [
    'svg.section', // can not use direct reference here because of recursive deps
    notificationModule.name,
  ])
  .factory('SectionSvgUpload', SectionSvgUpload)
  .directive('sectionSvgUpload', sectionSvgUpload);
